import React, { Component } from 'react'

class Board extends Component
{
	constructor(props) {
		super(props)
		this.state = {children: props.list}
		this.drop = this.drop.bind(this)
		this.dragOver = this.dragOver.bind(this)
		this.dragEnter = this.dragEnter.bind(this)
		this.dragLeave = this.dragLeave.bind(this)
	}

	drop(e) {
		e.preventDefault()
		const elem = document.getElementById(this.props.id)
		elem.style.background = "#e2e2e2"
		const cardId = JSON.parse(e.dataTransfer.getData("card-id"))
		const card = document.getElementById(cardId.tid)
		card.style.display = "block"
		var cards = e.target.children
		if(cards.length >= this.props.limit) {
			return
		}
		if(cardId.pid != 'board-1' && cardId.pid != 'ea-board-0' && cardId.pid != 'ea-board-1') {
			e.target.appendChild(card)
		}
		if(this.props.onCardAdded != null) {
			this.props.onCardAdded({id: card.id, name: card.innerText, pid: cardId.pid})
		}
		cards = Array.prototype.slice.call(cards)
		cards.sort((a, b) => {
			return(a.textContent.localeCompare(b.textContent))
		})
		if(this.props.onAdded) {
			this.props.onAdded(card.id, card, card.innerText)
		}
	}

	dragOver(e) {
		e.preventDefault()
	}

	dragEnter(e) {
		const elem = document.getElementById(this.props.id)
		elem.style.background = "#8FA741"
	}

	dragLeave(e) {
		const elem = document.getElementById(this.props.id)
		elem.style.background = "#e2e2e2"
	}

	componentDidUpdate(prevProps) {
		if(this.props.style != prevProps.style) {
			this.setState({cStyle: this.props.style})
		}
		if(this.props.list != prevProps.list) {
			this.setState({children: this.props.list})
		}
	}

	render() {
		return(<div id={this.props.id} className="board" onDrop={this.drop}
			onDragEnter={this.dragEnter} onDragLeave={this.dragLeave} onDragOver={this.dragOver}
			style={{height: this.state.cStyle}}>
			{this.state.children}
	 	</div>)
	}
}

export default Board
